import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    width: 'fit-content',
    minWidth: '1070px',
    maxWidth: '95% !important',
    height: '780px',
    maxHeight: '90%',
    overflow: 'hidden',
    borderRadius: '8px',
    '@media (max-width: 1100px)': {
      width: '95%',
      minWidth: 'unset',
    },
  },
  dialogHeader: {
    paddingLeft: 20,
    paddingRight: 13,
    ...theme.dialogs.header,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 60,
    minHeight: 60,
  },
  headerTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 10,
  },
  headerTitle: {
    ...theme.dialogs.title,
    color: theme.palette.primary.dark,
    marginLeft: 10,
    fontSize: '18px',
    fontFamily: 'Roboto',
  },
  dialogContent: {
    display: 'flex',
    flexFlow: 'row nowrap',
    flex: 1,
    overflowY: 'scroll',
  },
  rightSideContainer: {
    padding: '16px',
  },
  leftSideContainer: {
    padding: '16px',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '1%',
      bottom: '1%',
      right: -2,
      width: '1px',
      backgroundColor: '#d5d2d5',
    },
  },
  borderBottom: {
    borderBottom: '1px solid #E1E2EA !important',
  },
  tableCell: {
    ...theme.tables.tableCell,
    fontSize: '15px',
    padding: '0 15px !important',
    height: '50px',
    border: 0,
  },
  tableCellBold: {
    fontWeight: '500',
  },
  noPadding: {
    padding: '0 !important',
  },
  valueCellsTitle: {
    display: 'flex',
    alignItems: 'center',
    height: '50px',
    fontWeight: '500 !important',
  },
  tableHeadCell: {
    fontSize: '16px',
    fontFamily: 'Roboto',
    color: theme.palette.primary.dark,
    padding: '0 15px !important',
    backgroundColor: '#fff',
    textTransform: 'none',
    height: '40px',
  },
  enumerationCellContent: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between',
  },
  actionsContainer: {
    borderTop: '1px solid #d5d2d5',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '20px 10px',
    width: '100%',
    zIndex: 3,
  },
  iconBtnStyle: {
    width: 30,
    height: 30,
    borderRadius: 6,
    padding: 0,
    marginLeft: 10,
  },
  label: {
    fontSize: '16px',
    fontWeight: 400,
    textAlign: 'left',
    paddingLeft: '10px',
  },
  inputRoot: {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    height: '25px',
    fontSize: '14px',
    lineHeight: 'normal',
    display: 'flex',
    alignItems: 'center',
  },
  enumerationsListWrapper: {
    height: 90,
    overflow: 'auto'
  },
  enumerationsFormWrapper: {
    height: 210,
    overflow: 'auto',
    '& .MuiTableCell-stickyHeader': {
      backgroundColor: '#fff',
    }
  },

  //This is here because style attribute does not allow "important".
  enumerationCellStyles: {
    paddingTop: '10px !important',
    verticalAlign: 'top'
  },
  stepLabelWrapper: {
    height: 30,
    display: 'flex',
    alignItems: 'center',
  },
  stepHelperText: {
    margin: 0,
    position: 'absolute',
    top: '100%',
    left: 0,
    whiteSpace: 'nowrap',
    width: '160px',
  },
  stepRow: {
    display: 'block',
    paddingBottom: '4px !important',
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    paddingLeft: '5px !important',
  },
  currentValueRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'nowrap',
    minWidth: 0,
  },
  currentValueDisplay: {
    width: '90px',
    fontSize: '14px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  valueRefreshBtn: {
    padding: '2px',
    flexShrink: 0,
  },
  spinning: {
    '& svg': {
      animation: '$rotate 1s linear infinite',
    },
  },
  '@keyframes rotate': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
  writeValueSelect: {
    width: '140px',
    minWidth: 0,
    maxWidth: '140px',
    flexShrink: 1,
  },
  writeValueSelectRoot: {
    paddingTop: '0 !important',
    paddingRight: '32px !important',
    paddingBottom: '0 !important',
    height: '25px !important',
    fontSize: '14px !important',
    lineHeight: '25px',
  },
  menuItem: {
    maxWidth: '250px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  writeValueInput: {
    width: '80px',
    '& .MuiOutlinedInput-root': {
      height: '25px',
      fontSize: '14px',
    },
  },
  writeValueInputRoot: {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    height: '25px',
    fontSize: '14px',
  },
  setValueBtn: {
    textDecoration: 'underline',
    textTransform: 'none',
    fontSize: '14px',
    padding: '0 4px',
    minWidth: 'unset',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  setNewValueLabel: {
    fontSize: '15px',
    fontWeight: '500',
    padding: '0 4px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  currentValueActionsWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: 0,
  },
  setButton: {
    height: '25px !important',
    minHeight: '25px !important',
    minWidth: '100px !important',
    padding: '0 12px !important',
    fontSize: '13px !important',
    fontWeight: '500 !important',
  },
  flippedSaveAlt: {
    transform: 'scaleY(-1)',
    fontSize: '17px !important',
  },
  versionTooltip: {
    whiteSpace: 'nowrap !important',
    maxWidth: 'none !important',
  },
  width170: {
    width: '170px',
  }
}));

export default useStyles;
